import React from 'react';
import { useParams } from 'react-router-dom';
import * as TestModule from 'modules/test';
import { ExamBuilder } from 'modules/standardizedExam/components/authoring/ExamBuilder';
import type { AuthorSection } from 'modules/standardizedExam/types';
import { SubjectBuilderPage } from './SubjectBuilderPage';

/**
 * The test's content step. IELTS-style and Digital SAT practice tests get the
 * section builder; every other test keeps the existing subject/question builder.
 */
export const QuestionsTab: React.FC = () => {
  const { testId = '' } = useParams<{ testId: string }>();
  const { item: test, isLoading } = TestModule.Hooks.useSingle({ id: testId, enabled: Boolean(testId) });

  if (isLoading) return null;
  if (test?.examConfig) {
    return (
      <ExamBuilder
        testId={testId}
        config={test.examConfig}
        sections={(test.sections ?? []) as unknown as AuthorSection[]}
        status={test.status}
        totalMinutes={test.settings?.timeLimit}
      />
    );
  }
  return <SubjectBuilderPage />;
};

export default QuestionsTab;
